export function UniqueArray(theKey, theJSON) {
  var uniqueValues = [
    ...new Map(theJSON.map((item) => [item[theKey], item])).values(),
  ];
  uniqueValues.sort((a, b) => a[theKey].localeCompare(b[theKey]));
  return uniqueValues;
}
